import React from 'react';
//import saskPork from '../Images/Sask+Pork_Primary+Vertical_RGB.png';
import ontarioBeef from '../Images/BeefOntario.png';
import mtas from '../Images/MTAS-logo-400x143.jpg';
import publicHealthC from '../Images/Public Health Agency of Canada (PHAC).jpg';
import acfa from '../Images/ACFA-web-logo.png';
import bcrc from '../Images/BCBR-design-394x330.png';
import uniSask from '../Images/University of Saskatchewan .jpg';
import canadianWild from '../Images/Canadian Cooperative Wildlife Health Centre .jpg';
import '../App.css';

const CompanyLogos = () => {
  const companies = [
    //{ name: 'saskPork', logo: saskPork, url: 'https://www.saskpork.com' },
    { name: 'Ontario Beef', logo: ontarioBeef, url: 'https://www.ontariobeef.com' },
    // { name: 'mtas', logo: mtas, url: 'https://www.saskmassagetherapy.com' },
    { name: 'Public Health Agency of Canada', logo: publicHealthC, url: 'https://www.canada.ca/en/public-health.html' },
    { name: 'acfa', logo: acfa, url: 'https://cattlefeeders.ca/' },
    { name: 'bcrc', logo: bcrc, url: 'https://www.beefresearch.ca/' },
    { name: 'University of Sask', logo: uniSask, url: 'https://www.usask.ca' },
    { name: 'Canadian Wild', logo: canadianWild, url: 'https://www.cwhc-rcsf.ca/' },
  ];

  return (
    <section id="Collaborators" style={{ padding: '60px 20px' }}>
      {/* Small, clean heading for an institutional feel */}
      <h2 style={headerStyle}>
        Notable Project Clients & Partners
      </h2>
      
      {/* This container uses the grid styles from your App.css */}
      <div className="logo-grid-container">
        {companies.map((company, index) => (
          <a 
            key={index} 
            href={company.url} 
            target="_blank" 
            rel="noopener noreferrer"
            title={company.name}
          >
            <img
              src={company.logo}
              alt={company.name}
              className="logo-item" /* Using the CSS class for monochrome + hover */
            />
          </a>
        ))}
      </div>
    </section>
  );
};

// Simple inline style for the header to keep it consistent
const headerStyle = {
  fontSize: '13px',
  fontWeight: '700',
  letterSpacing: '1.5px',
  color: '#94a3b8',
  textTransform: 'uppercase',
  marginBottom: '40px',
  textAlign: 'center'
};

export default CompanyLogos;